export default __webpack_public_path__ + "661fe678156cccdad01d85d342dc94a8.png";